import { gql } from 'apollo-boost'

export default function getQueryLots(variables) {
  return {
    query: gql`
      query getLots(
        $start: Int = 0
        $limit: Int = 0
        $searchTerm: String
        $sortOption: LotSortOption
      ) {
        lots(start: $start, limit: $limit, searchTerm: $searchTerm, sortOption: $sortOption) {
          total
          values {
            ... on Lot {
              id
              lotNumber
              status
              itemId
              batchId
              projectedPieces
              projectedManHours
              runId
              attachments {
                assetId
                employeeId
                size
              }
              dateCompleted
              closeNotes
              progress
              completedPieces
              completedManHours
              components {
                componentId
                quantity
                available
                quantityRequired
                leadTime
              }
            }
          }
          skip
          limit
        }
      }
    `,
    variables,
    fetchPolicy: 'cache-and-network',
  }
}



// WEBPACK FOOTER //
// ./src/graphql/Lots.js